// Account Settings Constants

export const SETTINGS_ROUTES = {
  ACCOUNT_SETTINGS: '/account-settings',
  ACCOUNT_SETTINGS_CANDIDATE: '/candidate/account-settings',
  ACCOUNT_SETTINGS_COMPANY: '/company/account-settings',
} as const;

export const DEVICE_TYPES = {
  LAPTOP: 'laptop',
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
} as const;

export const DEVICE_ICONS: Record<string, string> = {
  laptop: 'laptop',
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop-mobile',
};

export const NOTIFICATION_SETTINGS = [
  {
    id: 'newJob',
    title: 'New job',
    description: 'Notify me when an employer rejected me.',
    defaultValue: true,
  },
  {
    id: 'applicationResult',
    title: 'Application result',
    description: 'Notify me when an employer rejected me.',
    defaultValue: true,
  },
  {
    id: 'messages',
    title: 'Messages',
    description: 'Notify me when an employer rejected me.',
    defaultValue: false,
  },
] as const;

export const VALIDATION_MESSAGES = {
  REQUIRED_FIRST_NAME: 'First name is required',
  REQUIRED_LAST_NAME: 'Last name is required',
  REQUIRED_EMAIL: 'Email address is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  REQUIRED_OLD_PASSWORD: 'Current password is required',
  REQUIRED_NEW_PASSWORD: 'New password is required',
  PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters',
  PASSWORD_MATCH: 'Passwords do not match',
  PASSWORD_REQUIREMENTS:
    'Password must contain uppercase, lowercase, number, and special character',
  EMAIL_MATCH: 'New email cannot be the same as current email',
} as const;

export const SUCCESS_MESSAGES = {
  PERSONAL_INFO_UPDATED: 'Personal information updated successfully',
  EMAIL_UPDATED: 'Email address updated successfully. Please verify your new email.',
  PASSWORD_UPDATED: 'Password updated successfully',
  NOTIFICATIONS_UPDATED: 'Notification preferences updated',
  DEVICE_TERMINATED: 'Device session terminated successfully',
  ALL_SESSIONS_TERMINATED: 'All other sessions have been terminated',
} as const;

export const ERROR_MESSAGES = {
  UPDATE_FAILED: 'Failed to update settings. Please try again.',
  INVALID_PASSWORD: 'Current password is incorrect',
  EMAIL_TAKEN: 'This email address is already in use',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  DELETE_ACCOUNT_FAILED: 'Failed to delete account. Please try again.',
} as const;

export const DELETE_ACCOUNT_WARNING =
  "We'd hate to see you go, but you're welcome to delete your account anytime. Just remember, once you delete it, it's gone forever delete it, it's gone forever delete it, i";

export const SECURITY_INFO = {
  WHY_HIDDEN: {
    title: "Why isn't my info shown here?",
    description:
      "We're hiding some account details to protect your identiWe're hiding some account details to protect your identity.We're hiding some account details to protect your identity.We're hiding some account details to protect your identity.We're hiding some",
  },
  EDITABLE_DETAILS: {
    title: 'Which details can be edited?',
    description:
      "Details Airbnb uses to verify your identity can't be changed. Contact info and some personal details can be edited, but we may ask you verify your identity the next time you book or create a listing.",
  },
} as const;
